import { Reveal, SectionLabel } from "./Reveal";
import { IMAGES } from "../data/content";

export const Manifesto = () => (
  <section
    id="agenzia"
    data-testid="about-section"
    className="relative py-24 sm:py-32 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <SectionLabel>L'Agenzia</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-serif-display text-2xl sm:text-3xl lg:text-[2.6rem] font-medium leading-snug mt-6 text-[#F4F1EE]">
            Un'esperienza che dura da{" "}
            <span className="italic text-gold-gradient">oltre 30 anni</span>:
            abbiamo portato show, voci e artisti dove meritavano di stare —{" "}
            <span className="italic text-gold-gradient">sotto i riflettori</span>.
            Da qui si riparte per{" "}
            <span className="italic text-[#D92B34]">un nuovo viaggio.</span>
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-6 text-base sm:text-lg text-[#A19CAE] leading-relaxed max-w-xl">
            Casting, management, produzioni e tanto altro ancora...
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              ["Casting & Management", "Scouting e gestione carriere di artisti, musicisti e modelle."],
              ["Regia & Allestimento", "Direzione artistica di show, sfilate ed eventi dal vivo."],
              ["Produzione Integrata", "Set TV e cinema, studio discografico e distribuzione."],
            ].map(([t, d]) => (
              <div key={t} className="border-l border-[#E6C594]/30 pl-5">
                <h3 className="font-semibold text-[#F4F1EE]">{t}</h3>
                <p className="mt-2 text-sm text-[#A19CAE] leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-5">
        <div className="relative">
          <div className="rounded-2xl overflow-hidden border border-[#282338] -rotate-2">
            <img
              src={IMAGES.backstage}
              alt="Backstage di una sfilata di moda"
              loading="lazy"
              className="w-full h-[26rem] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 rounded-xl overflow-hidden border border-[#E6C594]/40 w-40 rotate-3 shadow-[0_20px_50px_-20px_rgba(217,43,52,0.4)]">
            <img
              src={IMAGES.couture}
              alt="Abito haute couture in passerella"
              loading="lazy"
              className="w-full h-52 object-cover"
            />
          </div>
          <p className="font-mono-label text-[10px] tracking-[0.3em] text-[#E6C594]/80 mt-4 text-right">
            BACKSTAGE — FASHION WEEK
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
